// QRCodeGenerator.jsx
import React from 'react';
import { QRCodeSVG  } from 'qrcode.react';

const QRCodeGenerator = ({ gymId }) => {
  const deepLink = `yupluck://GymDetails/${gymId}`;

  return (
    <div className="flex flex-col items-center justify-center p-4 bg-white rounded-xl shadow-lg">
      <h2 className="text-xl font-semibold mb-4">Scan to Open Gym Details</h2>
      <QRCodeSVG
        value={deepLink}
        size={200}
        bgColor="#ffffff"
        fgColor="#000000"
        level="H"
        includeMargin={true}
      />
      <p className="mt-4 text-sm text-gray-600 break-all text-center">{deepLink}</p>
    </div>
  );
};

export default QRCodeGenerator;
